// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import Rails from '@rails/ujs'
window.Rails = Rails
Rails.start()
